import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    labels: Array,
    data: Array,
    colors: Array
  }

  connect() {
    this.loadLibrary()
  }

  async loadLibrary() {
    const { Chart, DoughnutController, ArcElement, Tooltip, Legend } = await import("chart.js")
    Chart.register(DoughnutController, ArcElement, Tooltip, Legend)

    if (this.isDisconnected) return

    this.chart = new Chart(this.element, {
      type: "doughnut",
      data: {
        labels: this.labelsValue,
        datasets: [{
          data: this.dataValue,
          backgroundColor: this.colorsValue,
          borderWidth: 0,
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "70%",
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${ctx.parsed}%`
            }
          }
        }
      }
    })
  }

  disconnect() {
    this.isDisconnected = true
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
